var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3579_3653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 1.66675H3.33341C2.41294 1.66675 1.66675 2.41294 1.66675 3.33341V6.66675C1.66675 7.58722 2.41294 8.33341 3.33341 8.33341H16.6667C17.5872 8.33341 18.3334 7.58722 18.3334 6.66675V3.33341C18.3334 2.41294 17.5872 1.66675 16.6667 1.66675Z",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 11.6667H3.33341C2.41294 11.6667 1.66675 12.4129 1.66675 13.3334V16.6667C1.66675 17.5872 2.41294 18.3334 3.33341 18.3334H16.6667C17.5872 18.3334 18.3334 17.5872 18.3334 16.6667V13.3334C18.3334 12.4129 17.5872 11.6667 16.6667 11.6667Z",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5H5.00833",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15H5.00833",
    stroke: "#00FFA3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3579_3653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodes);
export default __webpack_public_path__ + "static/media/nodes.02affbd39735617a9e1bd800a6e4159e.svg";
export { ForwardRef as ReactComponent };